
import React, { useState, useEffect } from 'react'
import * as XLSX from 'xlsx';
import axios from 'axios';
import {baseUrl, limit} from "../../../comman/config";
import { can } from "../../../comman/permissions";
import { useNavigate, Link } from 'react-router-dom';
import Select from 'react-select';
import { ItemNameStacked } from '../../../components/ItemName';
import { menuAboveTable } from "../../../comman/selectMenu";
// import Pagination from "react-js-pagination";

function List() {

    const [consumptionMasterList, setConsumptionMasterList] = useState([]);
    const [method, setMethod] = useState([]);
    const [filteredList, setFilteredList] = useState([]);
    const [page, setPage] = useState(1);
    const [totalItem, setTotalItem] = useState(0);
    const [popupOpen, setPopupOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [methodList, setMethodList] = useState([]);
    const [category, setCategory] = useState([]);
    const [categoryList, setCategoryList] = useState([]);
    // Status defaults to Active, matching the other master lists. '' is All.
    // Needs sql/consumption_master_status.sql -- this table had no status column before it.
    const [statusFilter, setStatusFilter] = useState({ value: '1', label: 'Active' });

    // role 0 = superadmin, 1 = admin. Both may enable and disable; only the superadmin may delete.
    const role = String(localStorage.getItem('userRole'));
    // Which buttons this user gets is Role Master's call now, not a role number's -- see
    // comman/permissions.js. `role` is still read because it is what the delete and enable
    // endpoints are told to check against.
    const canDisable = can('disable');
    const canActivate = can('active');
    const canDelete = can('delete');

    // A list header names a whole column, so it can only follow the category when the list is
    // actually showing one: filter to Rotli and the Density header becomes what that figure is
    // for Rotli -- the weight of one piece, not a density. Mixed or unfiltered, it stays the
    // general name, because the column then holds both meanings at once. The Add/Edit screen has
    // no such ambiguity and renames from the item's own category.
    const ROTLI_CATEGORY_NAME = 'રોટલી';
    const showingRotliOnly =
        category.length > 0 &&
        category.every((selected) =>
            categoryList.some((c) => c.id === selected.value && c.name === ROTLI_CATEGORY_NAME)
        );
    const densityLabel = showingRotliOnly ? 'Density or 1 Piece (Kgs)' : 'Density';
    const navigate = useNavigate();

    useEffect(() => {
        getMenuitems();
        getMethodList()
        getCategoryList()
    }, []);

    const getCategoryList = async () => {
        const response = await axios.get(
          `${baseUrl}/comman/list?table=item_category_master&condition=status=1`
        );
        setCategoryList(response.data.data);
      };

    const getMethodList = async () => {
        const response = await axios.get(
          `${baseUrl}/comman/list?table=method_master&condition=status=1`
        );
        setMethodList(response.data.data);
      };

    useEffect(() => {
        let filterelist = consumptionMasterList;
        console.log(filterelist)
        if (method && method.length > 0) {
            console.log(method)
            const methodIds = method.map((method) => method.value);
            filterelist = filterelist.filter((item) => methodIds.includes(item.method_id));
        }
        // Matched on category_id rather than the displayed name: the list query resolves the
        // category through item_master.category, and two categories could share a name.
        if (category && category.length > 0) {
            const categoryIds = category.map((c) => c.value);
            filterelist = filterelist.filter((item) => categoryIds.includes(item.category_id));
        }
        if (searchQuery) {
            filterelist = filterelist.filter((item) => {
                return item.eng_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                       item.item_name.toLowerCase().includes(searchQuery.toLowerCase());
            });
        }
        const status = statusFilter?.value ?? '';
        if (status !== '') {
            filterelist = filterelist.filter((item) => String(item.status) === status);
        }
        setFilteredList(filterelist);
        // consumptionMasterList is a dependency: the fetch no longer seeds filteredList, so the
        // default Active filter holds from the first render rather than after the first keystroke.
    }, [searchQuery, method, category, statusFilter, consumptionMasterList]);
    const getMenuitems = async () => {
        // console.log(page);
        setPopupOpen(true);
        const response = await axios.get(`${baseUrl}/consumption_master/list?page=${page}&limit=${limit}`, {
           
        });
        setPopupOpen(false);
        setConsumptionMasterList(response.data.data);
        setTotalItem(response.data.totalItem);
    }

    const handelFilterChange= (e) => {
        const { value } = e.target;
        setSearchQuery(value);
    };

    const handleClear = () => {
        setSearchQuery('');
        setMethod([]);
        setCategory([]);
        setStatusFilter({ value: '1', label: 'Active' });
    };

    const disableRow = async (id) => {
        if (!window.confirm("Are you sure you want to disable this row?")) return;
        try {
            await axios.delete(`${baseUrl}/consumption_master/delete/${id}`, { data: { role } });
            window.location.reload();
        } catch (error) {
            alert(error?.response?.data?.msg ?? 'Could not disable the row.');
        }
    };

    const enableRow = async (id) => {
        if (!window.confirm("Enable this row?")) return;
        try {
            await axios.post(`${baseUrl}/consumption_master/enable/${id}`, { role });
            window.location.reload();
        } catch (error) {
            alert(error?.response?.data?.msg ?? 'Could not enable the row.');
        }
    };

    // Delete removes the row, unlike Disable which is recoverable, so its confirmation says so.
    // Whether the item has been served -- and so still needs these standards for its reports -- is
    // the backend's call; it refuses with the reason, which is what gets shown here.
    const destroyRow = async (id) => {
        if (!window.confirm("Permanently DELETE this row? Disable is reversible; this is not.")) return;
        try {
            await axios.delete(`${baseUrl}/consumption_master/destroy/${id}`, { data: { role } });
            window.location.reload();
        } catch (error) {
            alert(error?.response?.data?.msg ?? 'Could not delete the row.');
        }
    };



    const editMenuitem = async (id) => {
        navigate(`/consumption_master/edit/${btoa(id)}`, { state: consumptionMasterList.filter(item => item.id == id) });
    }

    // .xlsx, not .csv. A CSV declares no encoding, so Excel reads it in the local codepage and
    // the Gujarati menu item and category names come out as mojibake. An xlsx carries UTF-8.
    const handleExport = () => {
        // Column order is the spec's, and the two names are now separate columns rather than
        // "Guj (Eng)" in one -- a sheet gets sorted and filtered on, and a combined cell cannot be.
        const header = [
            "Menuitem Name (Guj)", "Menuitem Name (Eng)", "Menuitem Category", "Method",
            "RM to FG", "FG / Person", densityLabel, "Bowl QTY", "Avg / Bowl",
            "RAS", "STD RAS", "RM to Bowl", "RM to FG Atta Multiplier",
        ];
        const rows = filteredList.map((item) => ([
            item.item_name,
            item.eng_name,
            item.category,
            item.method,
            item.rm_to_fg_ratio,
            item.fg_consumption_per_person,
            item.avg_density,
            item.one_bowl_qty,
            item.avg_consumption_per_bowl,
            // RAS is the live figure, STD RAS the standard it is measured against -- the same
            // pairing the list screen shows, and the reason both are here.
            item.raw_mat_per_100_person,
            item.ras_raw_mat_per_100_person,
            item.rm_to_bowl_ratio,
            item.raw_atta_to_finished_atta_multiplier,
        ]));
        const worksheet = XLSX.utils.aoa_to_sheet([header, ...rows]);

        // Widths from the longest value in each column, so a sheet of thirteen columns is readable
        // when it opens. Bold, borders and page setup are Pro features of xlsx and never reach the
        // file, so they are not attempted.
        const columnWidth = (index) => {
            const cells = [header[index], ...rows.map((row) => row[index])];
            const longest = cells.reduce((max, cell) => Math.max(max, String(cell ?? '').length), 0);
            return { wch: Math.min(Math.max(longest + 2, 10), 40) };
        };
        worksheet['!cols'] = header.map((_, index) => columnWidth(index));
        worksheet['!rows'] = [{ hpt: 20 }];
        worksheet['!margins'] = { left: 0.3, right: 0.3, top: 0.4, bottom: 0.4, header: 0.2, footer: 0.2 };

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Consumption Master");
        XLSX.writeFile(workbook, "Consumption-Master.xlsx");
    }
   
    const handleChangeMultiSelect = (selected, name) => {
        if(name === 'method'){
            setMethod(selected);
        }
        if(name === 'category'){
            setCategory(selected);
        }
    };


    return (
        <div className="p-4">
            <div className="flex justify-between items-center py-4 px-6">
                <h1 className="text-lg sm:text-xl md:text-xl lg:text-xl xl:text-2xl font-bold">Consumption Master List</h1>
                <div>
                    <Link to="/consumption_master/add">
                        <button className="px-4 py-2 bg-blue-500 text-white rounded-md mr-4 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200">Add Consumption Master</button>
                    </Link>
                    <button
                    onClick={handleExport}
                    className="px-4 py-2 bg-blue-500 text-white rounded-md mr-4 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200"
                >
                    Export
                </button>
                </div>
            </div>
            <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                {/* One row, per spec: search, category, method, status, clear. These were two
                    rows -- the search box on its own above the two dropdowns -- which made the
                    filters read as two unrelated controls rather than one set. flex-wrap keeps it
                    honest on a narrow screen: one line where there is room, wrapped where not. */}
                <div className="pb-4 flex flex-wrap items-center gap-3">
                    <label htmlFor="table-search" className="sr-only">Search</label>
                    <div className="relative">
                        <div className="absolute inset-y-0 left-0 rtl:inset-r-0 rtl:right-0 flex items-center ps-3 pointer-events-none">
                            <svg className="w-5 h-5 text-gray-500 dark:text-gray-400" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd"></path></svg>
                        </div>
                        <input type="text" value={searchQuery} onChange={handelFilterChange} id="table-search" className="block p-2 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg w-64 bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Search for items" />
                    </div>
                    <div className="w-56">
                        <Select
                            {...menuAboveTable}
                            isMulti
                            classNamePrefix="select"
                            className='basic-multi-select'
                            value={category}
                            name="category"
                            onChange={(selectedOptions) => handleChangeMultiSelect(selectedOptions, 'category')}
                            options={categoryList.map(item => ({
                                value: item.id,
                                label: item.eng_name ? `${item.name} (${item.eng_name})` : item.name
                            }))}
                            placeholder="Menuitem Category"
                            filterOption={(option, inputValue) => {
                                return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                            }}
                        />
                    </div>
                    <div className="w-48">
                        <Select
                            {...menuAboveTable}
                            isMulti
                            classNamePrefix="select"
                            className='basic-multi-select'
                            value={method}
                            name="method"
                            onChange={(selectedOptions) => handleChangeMultiSelect(selectedOptions, 'method')}
                            options={methodList.map(item => ({
                                value: item.id,
                                label: item.name
                            }))}
                            placeholder="Method List"
                            filterOption={(option, inputValue) => {
                                return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                            }}
                        />
                    </div>
                    <div className="w-36">
                        <Select
                            {...menuAboveTable}
                            classNamePrefix="select"
                            className='basic-multi-select'
                            value={statusFilter}
                            name="status"
                            onChange={(selected) => setStatusFilter(selected)}
                            options={[
                                { value: '', label: 'All' },
                                { value: '1', label: 'Active' },
                                { value: '0', label: 'Inactive' }
                            ]}
                            placeholder="Status"
                            isClearable={false}
                        />
                    </div>
                    <button
                        onClick={handleClear}
                        className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200"
                    >
                        Clear
                    </button>
                </div>
                <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                        <tr>
                            <th scope="col" className="px-6 py-3">Menuitem Name</th>
                            <th scope="col" className="px-6 py-3">Menuitem Category</th>
                            <th scope="col" className="px-6 py-3">Method</th>
                            <th scope="col" className="px-6 py-3">RM to FG</th>
                            <th scope="col" className="px-6 py-3">FG / Person</th>
                            <th scope="col" className="px-6 py-3">{densityLabel}</th>
                            <th scope="col" className="px-6 py-3">Bowl QTY</th>
                            <th scope="col" className="px-6 py-3">Avg / Bowl</th>
                            {/* RAS is the live figure, STD RAS the standard it is measured
                                against. This column was headed "Rm / 100-p" -- same figure,
                                a name that matched nothing else on the screen. */}
                            <th scope="col" className="px-6 py-3">RAS</th>
                            <th scope="col" className="px-6 py-3">STD RAS</th>
                            <th scope="col" className="px-6 py-3">RM to Bowl</th>
                            <th scope="col" className="px-6 py-3">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                    {filteredList.map((item) => (
                        <tr key={item.id} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                            <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"><ItemNameStacked item={item} /></th>
                            <td className={`px-6 py-4`}>{item.category}</td>
                            <td className={`px-6 py-4`}>{item.method}</td>
                            <td className={`px-6 py-4`}>{item.rm_to_fg_ratio}</td>
                            <td className={`px-6 py-4`}>{item.fg_consumption_per_person}</td>
                            <td className={`px-6 py-4`}>{item.avg_density}</td>
                            <td className={`px-6 py-4`}>{item.one_bowl_qty}</td>
                            <td className={`px-6 py-4`}>{item.avg_consumption_per_bowl}</td>
                            <td className={`px-6 py-4`}>{item.raw_mat_per_100_person}</td>
                            <td className={`px-6 py-4`}>{item.ras_raw_mat_per_100_person}</td>
                            <td className={`px-6 py-4`}>{item.rm_to_bowl_ratio}</td>
                            <td className="px-6 py-4">
                            <div className="flex gap-2">
                                <button
                                    type="button"
                                    onClick={() => editMenuitem(item.id)}
                                    className="px-3 py-1 text-sm bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200">
                                    Edit
                                </button>
                                {item.status == 1 && canDisable && <button
                                    type="button"
                                    onClick={() => disableRow(item.id)}
                                    className="px-3 py-1 text-sm bg-red-500 text-white rounded-md hover:bg-red-600 focus:outline-none focus:ring focus:ring-red-200">
                                    Disable
                                </button>}
                                {item.status == 0 && canActivate && <button
                                    type="button"
                                    onClick={() => enableRow(item.id)}
                                    className="px-3 py-1 text-sm bg-green-600 text-white rounded-md hover:bg-green-700 focus:outline-none focus:ring focus:ring-green-200">
                                    Enable
                                </button>}
                                {canDelete && <button
                                    type="button"
                                    onClick={() => destroyRow(item.id)}
                                    className="px-3 py-1 text-sm bg-red-700 text-white rounded-md hover:bg-red-800 focus:outline-none focus:ring focus:ring-red-300">
                                    Delete
                                </button>}
                            </div>
                            </td>
                        </tr>))}
           
                    </tbody>
                </table>
            </div>
        </div>
  );
}

export default List;